export default "__VITE_ASSET__CJaMZpwR__"